import { HttpClient } from './serviceBase';
import { utils } from '../utils/utils'

class InternalVoucherService {
    SearchInternalVouchers = async (pageSize, pageNumber, filters, branchId) => {
        const queryString = utils.GetQueryStringsFromObject({
            ...filters,
            branchId,
            pageSize,
            pageNumber
        })
        return await HttpClient.Get(`/api/internalVouchers?${queryString}`);
    }

    GetByInternalVoucherId = async (internalVoucherId) => {
        return await HttpClient.Get(`/api/internalVouchers/${internalVoucherId}`)
    }

    CreateInternalVoucher = async (internalVoucher) => {
        return await HttpClient.Post(`/api/orders/${internalVoucher.orderId}/change-payment`, internalVoucher)
    }
}

export default new InternalVoucherService();